import { useDispatch } from 'react-redux'
import { show } from './actions'

export const useModalForm = () => {
  const dispatch = useDispatch()
  return (...params) => dispatch(show(...params))
}
